// extracted by mini-css-extract-plugin
export default {"login":"eUGVn8","logOutText":"LcZX5c"};